import { AspectRatio } from "@mantine/core";

export default function OnboardingVideo() {
  return (
    <AspectRatio
      ratio={16 / 9}
      style={{ borderRadius: "8px", overflow: "hidden" }}
    >
      <iframe
        src="https://player.vimeo.com/video/1166414392?autoplay=1"
        style={{
          width: "100%",
          height: "auto",
          display: "block",
          border: 0,
          verticalAlign: "top",
        }}
        allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
        frameBorder="0"
        allowFullScreen
        title="Onboarding Video"
      />
    </AspectRatio>
  );
}
